import React from 'react';

import { InputView } from '@infoods/lifebase-ui';

import { FormFieldsGrid } from '../../FormFieldsGrid/FormFieldsGrid';

import classes from './ViewPrizeRow.module.scss';
import { RichTextViewer } from '../../../../../shared/features/rich-text';

type ViewPrizeRowProps = {
  title: string;
  description: string;
};

export const ViewPrizeRow = ({ title, description }: ViewPrizeRowProps) => {
  return (
    <FormFieldsGrid mode="VIEW">
      <div className={classes.prizeTitle}>{title}</div>
      <div className={classes.descriptionColumn}>
        <InputView
          label="Description"
          value={<RichTextViewer content={description} />}
          valueFont="inherit"
        />
      </div>
    </FormFieldsGrid>
  );
};
